// Airports data version checker
const AIRPORTS_DATA_VERSION = '2025.07.02';
const MAX_RELOAD_ATTEMPTS = 3;

export function checkAirportsDataVersion() {
  const storedVersion = localStorage.getItem('airports_data_version');
  const currentVersion = AIRPORTS_DATA_VERSION;
  
  if (storedVersion !== currentVersion) {
    localStorage.setItem('airports_data_version', currentVersion);
    
    // If this is not the first time and version changed, force reload
    if (storedVersion !== null) {
      console.warn('Airports data version updated. Forcing page reload to clear cache.');
      // Force hard reload to bypass cache
      window.location.reload(true);
      return false;
    }
  }
  return true;
}

export function validateAirportsData(airports) {
  // Check if eucustoms field exists in the data
  if (airports && airports.length > 0) {
    const firstAirport = airports[0];
    if (firstAirport && firstAirport.eucustoms === undefined) {
      console.error('Critical: eucustoms field is missing from airports data. This indicates cached outdated data.');
      
      // Check reload attempts to prevent infinite loop
      const reloadAttempts = parseInt(localStorage.getItem('airports_reload_attempts') || '0');
      
      if (reloadAttempts >= MAX_RELOAD_ATTEMPTS) {
        console.error('Maximum reload attempts reached. Please clear browser cache manually and refresh the page.');
        return false;
      }
      
      // Increment reload attempts
      localStorage.setItem('airports_reload_attempts', (reloadAttempts + 1).toString());
      
      // Clear version to force reload on next visit
      localStorage.removeItem('airports_data_version');
      
      // Force immediate reload with cache bypass
      const url = new URL(window.location.href);
      url.searchParams.set('cache_bust', Date.now());
      url.searchParams.set('force_reload', 'true');
      window.location.href = url.toString();
      
      return false;
    } else {
      // Data is valid, clear reload attempts counter
      localStorage.removeItem('airports_reload_attempts');
    }
  }
  return true;
}

// Helper function to manually clear cache and reset
export function clearAirportsCache() {
  localStorage.removeItem('airports_data_version');
  localStorage.removeItem('airports_reload_attempts');
  return true;
}
